import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";

const body = [
    { name: "Dr. Asha Rani Dash", remarks: "Chairperson" },
    { name: "Dr. Samata Jain", remarks: "Member" },
    { name: "Dr. Vandana Kashyap", remarks: "Member" },
    { name: "Dr. Poonam Verma", remarks: "Member" },
    { name: "Dr. Garima Diwan", remarks: "Member" },
    { name: "Mrs. Keshar Lata Sahu", remarks: "Member" },
    { name: "Ms. Vimla Sona", remarks: "Member" },
    { name: "Ms. Rekha Sahu", remarks: "Member" },
    { name: "Dr. N. Kumar Swamy", remarks: "Member" },
    { name: "Ms. Yogeshwari Dhruw", remarks: "Member" },
    { name: "Ms. Dev Kumari", remarks: "Member" },
    { name: "Ms. Uma Vishvkarma", remarks: "Member" },
    { name: "Mrs. Rameshwari Yadaw", remarks: "Member" },
    { name: "Mr. Sheetal Dhruw", remarks: "Member" },
    { name: "Mr. Faneesh Patel", remarks: "Member" }
];

const InternalComplaints = () => {
    return (
        <>
            <title>Internal Complaints Committee | ISBM University</title>
            <meta
                name="description"
                content="Learn how ISBM University’s ICC promotes safety with a zero-tolerance policy, confidential complaint handling, and awareness programs for all."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Internal Complaints Committee</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Internal Complaints Committee
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Internal Complaints Committee</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                ISBM University is committed to providing a safe, respectful, and inclusive campus
                                environment for all. In accordance with the guidelines of the University Grants Commission
                                (UGC) and the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal)
                                Act, 2013, the university has established an Internal Complaints Committee (ICC) to address
                                complaints related to sexual harassment and gender-based misconduct.
                            </p>
                            <p className="text-muted">
                                The ICC comprises trained faculty members, staff, and external experts to ensure a fair,
                                unbiased, and confidential redressal process. The committee actively conducts awareness sessions,
                                sensitization programs, and workshops to educate students and staff about their rights and responsibilities.
                                ISBM University strongly encourages individuals to report incidents without fear, reinforcing its
                                zero-tolerance policy towards harassment of any kind.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Internal Complaints Committee</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default InternalComplaints;
